import { render, staticRenderFns } from "./LoginMessage.vue?vue&type=template&id=3da18138&scoped=true"
import script from "./LoginMessage.vue?vue&type=script&lang=js"
export * from "./LoginMessage.vue?vue&type=script&lang=js"
import style0 from "./LoginMessage.vue?vue&type=style&index=0&id=3da18138&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da18138",
  null
  
)

export default component.exports